import { createStandardAction } from 'typesafe-actions'
import { OPEN_DRAWER, CLOSE_DRAWER, TOGGLE_DRAWER } from './constants'

export const openDrawer = createStandardAction(OPEN_DRAWER)();


export const closeDrawer = createStandardAction(CLOSE_DRAWER)();

export const toggleDrawer = createStandardAction(TOGGLE_DRAWER)();